import {ProcessNodeEditor} from "./ProcessNodeEditor.js";
import {BoxedObjectEditor} from "./BoxedObjectEditor.js";
import {calcCircleLineIntersectionPoint, drawTextBlock, normalizeAngle} from "./CanvasUtils.ts";

export const TASK_WIDTH = 96;
export const TASK_HEIGHT = 72;

export class TaskEditor extends ProcessNodeEditor {

	constructor(parent, node, coords) {
		super(parent, node, coords, true);
	}
	
	static calcRounding(width, height) {
		const dim = width <= height ? width : height;
		if (dim < 32) return Math.abs(dim / 2);
		return 16;
	}

	draw(ctx) {
		const rect = BoxedObjectEditor.strokeBox(this.coords.x, this.coords.y, this.coords.w, this.coords.h, this.lineWidth);
		ctx.save();
		ctx.strokeStyle = this.selected ? S.HI_COLORS[8] : "black";
		ctx.fillStyle = this.bg;
		ctx.lineWidth = this.lineWidth;
		const r = TaskEditor.calcRounding(rect.width, rect.height);
		
		ctx.beginPath();
		ctx.moveTo(rect.left+r, rect.top);
		ctx.lineTo(rect.left + rect.width - r, rect.top);
		ctx.arc(rect.left + rect.width - r, rect.top + r, r, Math.PI*1.5, 0);
		ctx.lineTo(rect.left + rect.width, rect.top + rect.height - r);
		ctx.arc(rect.left + rect.width - r, rect.top + rect.height - r, r, 0, Math.PI*0.5);
		ctx.lineTo(rect.left + r, rect.top + rect.height);
		ctx.arc(rect.left + r, rect.top + rect.height - r, r, Math.PI*0.5, Math.PI);
		ctx.lineTo(rect.left, rect.top + r);
		ctx.arc(rect.left + r, rect.top + r, r, Math.PI, Math.PI * 1.5);
		ctx.fill();
		ctx.stroke();
		ctx.restore();
		this.drawNodeName(ctx, rect);
	}

	calcIncomingArrowTip(angle) {
		const t = super.calcIncomingArrowTip(angle);
		//const rect = BoxedObjectEditor.strokeBox(this.coords.x, this.coords.y, this.coords.w, this.coords.h, 1);
		const r = TaskEditor.calcRounding(this.coords.w, this.coords.h);
		let d = null;


		let circleX = 0, circleY = 0;

		if (t.tipY > this.coords.y + this.coords.h / 2 - r) { // Bottom
			if (t.tipX > this.coords.x + this.coords.w / 2 - r) { // Right
				d = "bottom-right";
				circleX = this.coords.x + this.coords.w / 2 - r;
				circleY = this.coords.y + this.coords.h / 2 - r;

			} else if (t.tipX < this.coords.x - this.coords.w / 2 + r) { // Left
				d = "bottom-left";
				circleX = this.coords.x - this.coords.w / 2 + r;
				circleY = this.coords.y + this.coords.h / 2 - r;
			}

		} else if (t.tipY < this.coords.y - this.coords.h / 2 + r) { // top
			if (t.tipX > this.coords.x + this.coords.w / 2 - r) { // Right
				d = "top-right";
				circleX = this.coords.x + this.coords.w / 2 - r;
				circleY = this.coords.y - this.coords.h / 2 + r;
			} else if (t.tipX < this.coords.x - this.coords.w / 2 + r) { // Left
				d = "top-left";
				circleX = this.coords.x - this.coords.w / 2 + r;
				circleY = this.coords.y - this.coords.h / 2 + r;
			}
		}
		t.debug = d;
		if (circleX !== 0) {
			const intersections = calcCircleLineIntersectionPoint(
				{x:this.coords.x, y:this.coords.y},
				{x:t.tipX, y:t.tipY},
				{x:circleX, y:circleY},
				r);
			if (intersections.length === 1) {
				t.tipX = intersections[0].x;
				t.tipY = intersections[0].y;
			} else if (intersections.length === 2) {
				// pick the point which has bigger distance from the center
				//const p = TaskEditor.maxDistance(this.coords.x, this.coords.y, intersections[0], intersections[1]);
				const p = intersections[1];
				t.tipX = p.x;
				t.tipY = p.y;
			}
		}
		return t;
	}

	static maxDistance(x, y, pointA, pointB) {
		const da = TaskEditor.distance(x, y, pointA);
		const db = TaskEditor.distance(x, y, pointB);
		if (da > db) return pointA;
		else return pointB;
	}

	static distance(x, y, point) {
		return Math.sqrt(Math.pow(point.x - x, 2) + Math.pow(point.y - y, 2));
	}
}